import {Slide} from "react-slideshow-image";
import DemoCarAppSlide1 from "../assets/images/DemoCarAppSlide1.png";
import DemoCarAppSlide2 from "../assets/images/DemoCarAppSlide2.png";
import React from "react";

const SlideImagesReact = () => {
    const images = [
        /* If you intend to use url pictures just put the pictures url here*/

    ];
    return (
        <Slide >
            <div className="each-slide-effect ">

                <img src={DemoCarAppSlide1}  style={{width:"100%"}}/>

            </div>
            <div className="each-slide-effect">

                <img src={DemoCarAppSlide2}  style={{width:"100%"}}/>

            </div>



        </Slide>

    );
};

export default SlideImagesReact;
